﻿export const useAuthStore = defineStore('auth', () => {
    const auth = ref(null);
    const redirect = ref(null);

    const user = computed(() => auth.value?.User);
    const userName = computed(() => auth.value?.User.UserName);

    function set(u) {
        auth.value = u;
    }

    function hasRole(role) {
        if (!auth.value || !role) return false;

        let permitted =
            auth.value.User.Roles.indexOf('Global|Admin') > -1 ||
            auth.value.User.Roles.indexOf(role) > -1;

        return permitted;
    }

    return { auth, redirect, set, hasRole, user, userName }
}, {
    persist: {
        key: 'municrm.auth',
        storage: window.sessionStorage,
    },
})